import {Divider, Grid, Link, Typography} from "@mui/material";
import {formatDateUTCToLocal} from "../../util/DateUtil";
const FittingsDetailHeader = ({data}) => {
    if (!data) return null;
    const date = data.fittingScheduledEnd != "NA" ? formatDateUTCToLocal(data.fittingScheduledStart) : "";
    const time =
        data.fittingScheduledStart != "WALK UP"
            ? `${formatDateUTCToLocal(data.fittingScheduledStart, "hh:mmA")} - ${formatDateUTCToLocal(data.fittingScheduledEnd, "hh:mmA")}`
            : "WALK UP";
    return (
        <>
            <Grid item xs={12}>
                <Typography>
                    <strong>Location:</strong> {data?.locationAddress} (Ship To: {data.shipto})
                </Typography>
                {date && (
                    <Typography>
                        <strong>Date:</strong> {date}
                    </Typography>
                )}

                <Typography>
                    <strong>Time:</strong> {time}
                </Typography>
                <Typography>
                    <strong>Golf Professional: </strong>
                    {`${data?.event?.golfProFirstName ?? ""} ${data?.event?.golfProLastName ?? ""} ${data?.event?.golfProEmail ? `(${data?.event?.golfProEmail})` : ""}`}
                </Typography>
                <Typography>
                    <strong>TaylorMade Rep: </strong>
                    {`${data?.createdUser?.firstName ?? ""} ${data?.createdUser?.lastName ?? ""} (${data?.createdUser?.email ?? ""})`}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Divider />
                <Typography variant="subtitle1" mt={1}>
                    <strong>Golfer: {`${data?.golferFirstName} ${data?.golferLastName}`}</strong>
                </Typography>
                {data?.golferEmail && (
                    <Link sx={{textDecoration: "underline"}} href={`mailto:${data?.golferEmail}`}>
                        {data?.golferEmail}
                    </Link>
                )}
                <Typography>
                    <strong>Phone Number: {data?.golferPhoneNumber}</strong>
                </Typography>
            </Grid>
        </>
    );
};
export default FittingsDetailHeader;
